export default {
    namespaced: true,
    state: {
        // 用户信息
        showDownload: true,
        linkUrl: {},
        boxUrl: [
            {
                client_type: "1",
                url: "https://www.baidu.com/"
            },
            {
                client_type: "2",
                url: "https://tieba.baidu.com/"
            },
            {
                client_type: "3",
                url: "https://www.zhihu.com/"
            }
        ]
    },
    // getters:{},
    mutations: {
        setDownload(state: { showDownload: any; }, obj: any) {
            state.showDownload = obj
        },
    },
    actions: {
        async updateDownload({
            commit,
            // tslint:disable-next-line:align
        }, showDownload) {
            commit('setDownload', showDownload)
        },
    },
}
